<template>
  <div class="content content--contact">
    <div class="bg-img">
      <img src="../assets/images/hero-contact.jpg">
    </div>

    <MyHeader :breadcrumbItems=" [

        {
          name: 'Contact Us',
          path: this.$route.path
        },
      ]"/>

    <header class="content-header">
      <h1>Contact Us</h1>
    </header>

    <div class="main-content">
      <form>
        <h2>We are here to answer any questions or comments you may have.</h2>
        <p class="form-required"><span>*</span> This filed is required</p>
        <div class="form-block">
          <label>Subject <span class="required">*</span></label>
          <input type="text" required v-model="message.subject">
        </div>
        <div class="form-block">
          <label>Message <span class="required">*</span></label>
          <textarea required placeholder="Start typing..." v-model="message.content"></textarea>
        </div>
        <button class="button--submit button-icon" @click="sendMessage">Submit <i class="icon-send"></i></button>
      </form>
    </div>

    <transition name="fade">
      <div class="popup-wrapper" v-if="show">
        <div class="popup-overlay" @click="closePopup"></div>
        <div class="popup">
          <button class="popup-close" @click="closePopup"></button>
          <i class="icon-mail-1"></i>
          <div class="popup-title">Your message was sent successfully</div>
          <button class="button--submit" @click="closePopup">Close</button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import MyHeader from "@/components/general/Header";
import settings from "@/settings";
import api from '@/api/sendEmail'
export default {
  name: "ContactUs",
  components: { MyHeader },
  data () {
    return {
      message: {
        content: '',
        subject: '',
        topic: ''
      },
      show: false
    }
  },
  mounted() {
    window._paq.push(['setDocumentTitle', 'Contact Us']);
    window._paq.push(['trackPageView']);
  },
  methods: {
    closePopup () {
      this.show = 0
      this.$router.go(-1)
      document.querySelector('body').classList.remove('nooverflow')
    },
    sendMessage(e) {
      e.preventDefault()
      let data = {
        ...this.message,
        addresses: this.$store.getters.settingsCompanyBySettingTypeCode(settings.SETTING_TYPES.CONTACT_US_EMAILS).map(item => item.value),
        idUser: this.$store.getters.user.idUser
      }

      this.$gtag.event('SendContactRequest', {
        'event_category': this.$store.getters.company.name,
        'company_name': this.$store.getters.company.name,
        'event_label': 'ContactUs',
        'value': this.message.content
      })

      if(settings.ENV === 'STAGE') {
        data.addresses = ['joanna.lebica@capgemini.com']
        data.subject = `STAGE: ${data.subject}`
      }
      api.sendEmail(data, () => {
        this.show = 1
        document.querySelector('body').classList.add('nooverflow')
      })
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
